import { Box, ListItem, ListItemIcon, ListItemText, Typography, useTheme } from "@mui/material";
import { Block } from "../../../../shared";
import { ChevronRight } from "@mui/icons-material";
import { Icon } from "@iconify/react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface RowProps {
  icon: string;
  label: string;
  onClick: () => void;
  hideDivider?: boolean;
}

function Row({ icon, label, onClick, hideDivider }: RowProps) {
  const theme = useTheme();
  const dividerColor =
    theme.palette.mode === "dark" ? "#26262A" : "rgba(239, 239, 243, 1)";
  return (
    <>
      <ListItem
        onClick={onClick}
        sx={{
          paddingInline: 0,
          paddingBlock: "8px",
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "12px",
          cursor: "pointer",
        }}
      >
        <ListItemIcon
          sx={(theme) => ({
            backgroundColor:
              theme.palette.mode === "dark"
                ? "rgba(51,119,255,0.16)"
                : "rgba(51,119,255,0.10)",
            color: theme.palette.primary.main,
            minWidth: "36px",
            width: "36px",
            height: "36px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "10px",
            flexShrink: 0,
          })}
        >
          <Icon icon={icon} width={20} height={20} color="currentColor" />
        </ListItemIcon>

        <ListItemText
          sx={{ margin: 0, flexGrow: 1 }}
          primary={
            <Typography sx={{ fontSize: "15px", fontWeight: 500 }}>
              {label}
            </Typography>
          }
        />

        <ChevronRight sx={{ color: "#b0b0b0", flexShrink: 0 }} />
      </ListItem>
      {!hideDivider && (
        <Box
          sx={{
            height: "1px",
            backgroundColor: dividerColor,
            marginLeft: "48px",
          }}
        />
      )}
    </>
  );
}

export function PersonalDataBlock() {
  const navigate = useNavigate();
  const { t } = useTranslation("profile");

  return (
    <Block sx={{ paddingTop: "4px", paddingBottom: "4px" }}>
      <Row
        icon="solar:user-linear"
        label={t("blocks.personal")}
        onClick={() => navigate("/personal-data")}
      />
      <Row
        icon="solar:transfer-horizontal-linear"
        label={t("blocks.transfers", { defaultValue: "Переводы пользователям" })}
        onClick={() => navigate("/p2p")}
        hideDivider
      />
    </Block>
  );
}
